'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.roundUpVals = exports.roundVals = exports.scale = exports.difference = exports.translate = undefined;

var _fp = require('lodash/fp');

var _combine = require('../../utils/lib/combine');

var _combine2 = _interopRequireDefault(_combine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Lib
var translate = exports.translate = (0, _combine2.default)(_fp.add);

// Utils
var difference = exports.difference = (0, _combine2.default)(_fp.subtract);
var scale = exports.scale = (0, _fp.curry)(function (multiplier, multiplicandObj) {
    return (0, _fp.mapValues)((0, _fp.multiply)(multiplier), multiplicandObj);
});
var roundVals = exports.roundVals = (0, _fp.mapValues)(_fp.round);
var roundUpVals = exports.roundUpVals = (0, _fp.mapValues)(_fp.ceil);


//////////////////
// WEBPACK FOOTER
// ./src/common/maths/geometry/geometryUtils.js
// module id = 796
// module chunks = 0